import { render, staticRenderFns } from "./BaseRangeSelector.vue?vue&type=template&id=48df3217&scoped=true"
import script from "./BaseRangeSelector.vue?vue&type=script&lang=js"
export * from "./BaseRangeSelector.vue?vue&type=script&lang=js"
import style0 from "./BaseRangeSelector.vue?vue&type=style&index=0&id=48df3217&prod&lang=scss&scoped=true"
import style1 from "./BaseRangeSelector.vue?vue&type=style&index=1&id=48df3217&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48df3217",
  null
  
)

export default component.exports